<template>
  <div id="v-fields-usuarios">
    <v-layout row wrap>
      <v-flex xs12>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="nome"
          :validation="['required']"
          name="nome"
          label="Nome"
          v-model="gridConfig.editedItem.nome"
        ></MdText>
      </v-flex>
      <v-flex xs6>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="cnpj"
          :validation="['required']"
          name="cnpj"
          label="CNPJ"
          v-model="gridConfig.editedItem.cnpj"
        ></MdText>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
export default {
  name: "v-fields-empresas",

  props: {
    gridConfig: {},

    exclusao: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },

  created() {},

  methods: {
  },
};
</script>

<style>
</style>
